<script>
export default {
  props: {
    shipment: {
      type: Object,
      required: true,
      default: () => {},
    },
    orderData: {
      type: Object,
      required: true,
      default: () => {},
    },

    packingSlipUrl: {
      type: String,
      default: '',
    },
    packingSlipNumber: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {};
  },
  methods: {
    orderTypeIsClickAndCollect(orderType) {
      return (
        [
          'CLICK-AND-COLLECT',
          'CLICK-AND-COLLECT-NO-BIKE',
          'CLICK-AND-COLLECT-BIKE-OVERRIDE',
          'CLICK-AND-COLLECT_GROSS',
          'CLICK-AND-COLLECT_GROSS-OVERRIDE',
          'DEALER-DELIVERY',
          'CLICK-AND-COLLECT-NO-BIKE_GROSS',
          'DEALER-DELIVERY_GROSS',
          'ET',
        ].indexOf(orderType) > -1
      );
    },
  },
};
</script>
